"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
var filterAction;
(function (filterAction) {
    filterAction[filterAction["retry"] = 0] = "retry";
    filterAction[filterAction["disable"] = 1] = "disable";
})(filterAction || (filterAction = {}));
exports.default = vue_1.default.extend({
    name: 'turnstile',
    props: {
        sitekey: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            required: false,
            default: null,
        },
        action: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
            widgetId: undefined,
            filteredErrors: [
                { error: 'invalid_sitekey', action: filterAction.disable },
            ],
            retries: 0,
        };
    },
    methods: {
        render() {
            var _a;
            const renderOptions = {
                action: this.action,
                sitekey: this.sitekey,
                language: this.language || 'en',
                theme: 'light',
                callback: (token) => this.response(token),
                'error-callback': (err) => this.error(err),
                'expired-callback': () => this.expired(),
                retry: 'never',
            };
            this.widgetId = (_a = window.turnstile) === null || _a === void 0 ? void 0 : _a.render(this.$refs.turnstileContainer, renderOptions);
        },
        response(response) {
            this.$emit('response', response);
        },
        reset() {
            var _a;
            (_a = window.turnstile) === null || _a === void 0 ? void 0 : _a.reset(this.widgetId);
        },
        disable() {
            var _a;
            (_a = window.turnstile) === null || _a === void 0 ? void 0 : _a.remove(this.widgetId);
            this.$emit('disable');
        },
        error(err) {
            const filteredError = this.filteredErrors.find(x => x.error === err);
            if (filteredError !== undefined) {
                switch (filteredError.action) {
                    case filterAction.disable:
                        this.disable();
                        // eslint-disable-next-line no-console
                        console.error(`Turnstile disabled due to error ${filteredError.error}`);
                        return true;
                    case filterAction.retry:
                        if (this.retries < 3) {
                            this.retries++;
                            this.reset();
                            return true;
                        }
                        break;
                }
            }
            this.$emit('error', err);
            return true;
        },
        expired() {
            this.$emit('expired');
        },
    },
    mounted() {
        if (window.turnstile === null || !window.turnstile) {
            const script = document.createElement('script');
            script.src = this.src;
            script.addEventListener('load', () => this.render());
            script.addEventListener('error', () => this.disable());
            document.head.appendChild(script);
            return;
        }
        this.render();
    },
});
